export const newTabSlugs = [
  'base-script-creation-pending',
  'event-recording-pending',
  'stinger-recording-pending',
  'on-demand-recording-pending',
  'base-recording-pending',
  'timed-recording-pending',
  'network-esm-recording-pending',
  'network-odm-recording-pending',
  'to-voice-over',
  'event-recording-verification-pending',
  'event-rerecording-pending',
  'base-recording-verification-pending',
  'base-rerecording-pending',
  'on-demand-recording-verification-pending',
  'on-demand-rerecording-pending',
  'stinger-recording-verification-pending',
  'stinger-rerecording-pending',
  'timed-recording-verification-pending',
  'timed-rerecording-pending',
  'database_management',
  'business_management',
  'ok_to_download',
  'marketing',
  'product_representative',
  'music-review-pre-queue',
  'sponsor-content-review-to-copywriter',
  'music-review-instrumental-producer-process',
  'partner_success_manager',
  'revdev_initial_outreach',
  'production-file-review',
  'creative-account-branding',
  'demo-stinger-fulfilment',
  'demo-stinger-voice',
  'demo-stinger-production',
  'verify-partner-provided-details',
  'partner-provides-details',
  'sent-to-copywriter',
  'sponsor-content-review',
  'tnn-participation-form-ready',
  'song-request-recording-verification-pending',
  'demo-stinger-product-rep',
  'name_account_branding',
  'quality_issue',
  'demo-fulfilment-nr',
  'song-request-uploaded-file-rejected',
  'music-review-producer-process',
  'partner-provides-file',
  'network-esm-rerecording-pending',
  'network-odm-rerecording-pending',
  'global-commercial-rerecording-pending',
  'wristband-color-rerecording-pending',
  'song-request-rerecording-pending',
  'walkup-player-rerecording-pending',
  'partner-re-upload',
  'to-voice-over-rerecording',
  'tnn-campaign-schedule-rerecording-pending',
  'tnn-campaign-rerecording-pending',
  'network-esm-recording-verification-pending',
  'network-odm-recording-verification-pending',
  'global-commercial-recording-verification-pending',
  'wristband-color-recording-verification-pending',
  'walkup-player-recording-verification-pending',
  'sponsor-recording-verification-pending',
  'tnn-campaign-schedule-recording-verification-pending',
  'tnn-campaign-recording-verification-pending',
  'verify-sponsor-provided-details',
  'no-details-sent-to-copywriter',
  'sponsor-no-details-provided',
  'base-script-verification-pending',
  'stinger-script-verification-pending',
  'device_installation',
  'assign_voice_artist',
  'base-message-revisal',
  'verify-partner-provided-file',
  'verify-sponsor-provided-file',
  'users-primary-contact-removed',
  'users-primary-contact-added',
  'sponsor-provides-detail-review',
  'Music Review Pre Queue',
  'review-partner-financial-information',
  'verify-unsuspended-partner-has-paid',
  'alert-follow-up',
  'alert-follow-up-first',
  'review-partner-financial-information',
  'verify-unsuspended-partner-has-paid',
  'walkup-lineup-manual-rerecording-pending',
  'walkup-lineup-rerecording-pending',
  'walkup-lineup-manual-recording-pending',
  'walkup-lineup-recording-verification-pending',
  'walkup-lineup-manual-recording-verification-pending',
  'complete-tnn-pif',
  'no-numbers-received',
  'generate-demographic-data-for-tnn-opt-in',
  'create-tnn-partner-description',
  'create-tnn-audio-demo',
  'create-tnn-partner-thumbnail',
];

// this needs to be deleted once all route converted into new tab
